enum AccessTypesEnum {
    FULL = 1,
    RESTRICTED = 2,
    READ_ONLY = 3,
}

export default AccessTypesEnum;
